import { PlusIcon } from "@phosphor-icons/react/Plus";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import FullWidthLayout from "@/Shared/Layout/CustomComponents/FullWidthLayout";
import { CreditCardsAddButton } from "./Buttons/CreditCardsAddButton";
import { CreditCardsPanel } from "./Panels/CreditCardsPanel";
import { useCreditCards } from "./Hooks/useCreditCards";

function CreditCardsScreen() {
  const {
    creditCards,
    bankAccounts,
    initialLoading,
    retryFailedLoad,
    allowRemoveCardButton,
    showAddCreditCardDialog,
    showShareDialog,
    removeCard,
    setDefaultCard,
    dialogs,
  } = useCreditCards();

  const hasCards = creditCards.length > 0;

  return (
    <>
      {/* Outside the layout so the dialogs also work from the empty state. */}
      {dialogs}
      <FullWidthLayout
        header="Credit Cards"
        microcopy={
          <>
            You can manage your credit cards here. Don&apos;t have access to the
            company credit card?{" "}
            <Link onClick={showShareDialog}>
              Click here to invite someone else to add it
            </Link>
            .
          </>
        }
        rightContent={
          <Button primary icon={PlusIcon} onClick={showAddCreditCardDialog}>
            Add New Credit Card
          </Button>
        }
        loading={initialLoading}
        onRetryFailedLoad={retryFailedLoad}
        showEmptyState={!hasCards}
        emptyState={
          <Stack gap={6} align="center">
            <Stack gap={2} align="center">
              <Heading level={1}>
                You don&apos;t have any credit cards saved yet
              </Heading>
              <T color="secondary">
                Adding a credit card to FreightSimple makes it convenient and
                easy to pay for your freight.
              </T>
            </Stack>
            <Stack gap={4} align="center">
              <CreditCardsAddButton onClick={showAddCreditCardDialog} />
              <Button size="link" onClick={showShareDialog}>
                Don&apos;t have access to the company credit card? Click here to
                invite someone who does
              </Button>
            </Stack>
          </Stack>
        }
        content={
          <CreditCardsPanel
            creditCards={creditCards}
            bankAccounts={bankAccounts}
            setDefaultCard={setDefaultCard}
            removeCard={removeCard}
            allowRemoveCardButton={allowRemoveCardButton}
          />
        }
      />
    </>
  );
}

export default CreditCardsScreen;
